module.exports = __webpack_public_path__ + "static/media/positive.c154f573.png";